<template>
	<i class="icon" :class="`icon--${props.name}`" :style="`font-size: ${props.size}px`"></i>
</template>
<script lang="ts" setup>
import "./Icon.scss";

interface Props{
	name : string,
	size? : number,
}

let props = withDefaults(defineProps<Props>(), {
	size : 1
});

</script>